// extracted by mini-css-extract-plugin
export default {"wrapper":"SingleReceipt_wrapper__yDXEh","header":"SingleReceipt_header__zYJmc","list":"SingleReceipt_list__bPt3K","button":"SingleReceipt_button__MbPKG"};